import { render, staticRenderFns } from "./advertisingSDKManagement.vue?vue&type=template&id=b1b40d88&scoped=true&"
import script from "./advertisingSDKManagement.vue?vue&type=script&lang=js&"
export * from "./advertisingSDKManagement.vue?vue&type=script&lang=js&"
import style0 from "./advertisingSDKManagement.vue?vue&type=style&index=0&id=b1b40d88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b40d88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1b40d88')) {
      api.createRecord('b1b40d88', component.options)
    } else {
      api.reload('b1b40d88', component.options)
    }
    module.hot.accept("./advertisingSDKManagement.vue?vue&type=template&id=b1b40d88&scoped=true&", function () {
      api.rerender('b1b40d88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/packagingManagement/advertisingSDKManagement.vue"
export default component.exports